import { render } from "./StorageList.vue?vue&type=template&id=a99c1914"
import script from "./StorageList.vue?vue&type=script&lang=js"
export * from "./StorageList.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__